class LayerAutoroads {

	constructor(geometry) {
		this.geometry = geometry;
	}

	json() {
		LayerAutoroads.data = {
			type: 'FeatureCollection',
			features: (this.geometry?.coordinates ?? []).map((coords, idx) => ({
				type:       'Feature',
				id:         idx,
				properties: {},
				geometry: {
					type:        'LineString',
					coordinates: coords
				}
			}))
		};

		return {
			source: {
				type: 'geojson',
				data: LayerAutoroads.data
			},
			layer: [
				{
					id:     LayerAutoroads.layerId,
					type:   'line',
					source: LayerAutoroads.sourceId,
					layout: { 
						'line-cap': 'round', 
						'line-join': 'round' 
					},
					paint:  { 
						'line-color': LayerAutoroads.defaultColor, 
						'line-width': LayerAutoroads.defaultWidth
					}
				}
			]
		};
	}
}

LayerAutoroads.sourceId			= 'autoroads_aource';
LayerAutoroads.defaultWidth		= 6;
LayerAutoroads.defaultColor		= "#0048FF";
LayerAutoroads.layerId			= "autoroads_layer"

export default LayerAutoroads;
